import React from 'react';

export const IconBack = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.7105 6.71C14.3205 6.32 13.6905 6.32 13.3005 6.71L8.71047 11.3C8.32047 11.69 8.32047 12.32 8.71047 12.71L13.3005 17.3C13.6905 17.69 14.3205 17.69 14.7105 17.3C15.1005 16.91 15.1005 16.28 14.7105 15.89L10.8305 12L14.7105 8.12C15.1005 7.73 15.0905 7.09 14.7105 6.71Z" fill="currenColor"/>
    </svg>
  );
};
